export const colors = {
    brand: {
        50: '#d8f9ff',
        100: '#abe7ff',
        200: '#7bd5ff',
        300: '#49c4ff',
        400: '#1ab4ff',
        500: '#009ae6',
        600: '#0078b4',
        700: '#005682',
        800: '#003451',
        900: '#001221',
    },
};
//# sourceMappingURL=colors.js.map